import { Row, Typography } from "antd";
import { TableOutlined } from "@ant-design/icons";
import React from "react";

const { Text } = Typography;

interface DiagnosticViewTagProps {
    onClick: () => void;
}

const DiagnosticViewTag: React.FC<DiagnosticViewTagProps> = ({ onClick }) => {
    const tagStyle: React.CSSProperties = {
        backgroundColor: '#f5f5f5',
        border: '2px solid',
        borderRadius: '999px',
        borderColor: '#000000',
        cursor: 'pointer',
    };

    const tagTextStyle: React.CSSProperties = {
        padding: '2px 12px',
        fontSize: '12px',
        fontFamily: 'monospace',
        fontWeight: 'bold',
        color: '#000000',
        whiteSpace: 'nowrap',
    };

    return (
        <div onClick={onClick} style={{ cursor: 'pointer' }}>
            <Row>
                <Text>Diagnostic View <TableOutlined /></Text>
            </Row>
            <Row style={tagStyle}>
                <Text style={tagTextStyle}>Augers · Fans · Headspace</Text>
            </Row>
        </div>
    );
};

export default DiagnosticViewTag;
